class PostTemplate {
	getElement (post) {
		const div = document.createElement('div')
		div.innerHTML = this.getHtml(post)
		return div.firstElementChild
	}

	getHtml (post) {
		// Odkomentuj jeżeli chcesz sprawdzić dostępnę wartości na widoku
		let technicalCard = ''
		// console.log(post)
		if (post.technicalCard && post.technicalCard.name) technicalCard = /* html */ `	<a title="${post.technicalCard.name}" href="${post.technicalCard.file}" class="btn-download" download>`
		return /* html */ `
			<div class="product">
				<figure class="product-content">
					<a title="${post.title}" href="${post.link}">
					<picture>
						<source srcset="${post.imageWebpLink}" type="image/webp">
						<img alt="${post.title}" title="${post.title}" class="product-img" src="${post.imageLink}">
					<picture>

					</a>
					<div class="product-btn-wrapper">
						<a title="${post.title}" href="${post.link}" class="btn-product">Przejdź do produktu</a>
						${technicalCard}
						<svg xmlns="http://www.w3.org/2000/svg" width="15.86" height="17.8" viewBox="0 0 15.86 17.8">
						<g id="Group_629" data-name="Group 629" transform="translate(-142.393 -168.967)">
							<path id="Path_1189" data-name="Path 1189" d="M157.386,400.151H143.252a.859.859,0,1,0,0,1.717h14.143a.859.859,0,1,0-.009-1.717Z" transform="translate(0 -215.101)" fill="#fff"></path>
							<path id="Path_1190" data-name="Path 1190" d="M177.045,181.967a.852.852,0,0,0,1.254,0l5.032-5.4a.857.857,0,0,0-1.254-1.168l-3.546,3.8v-9.377a.859.859,0,1,0-1.717,0V179.2l-3.538-3.8a.857.857,0,0,0-1.254,1.168Z" transform="translate(-27.353 0)" fill="#fff"></path>
						</g>
						</svg>
					</a>
					</div>
				</figure>
			<p class="product-text">
				<strong>${post.title}</strong></p>
			</div>
		`
	}
}

const postTemplate = new PostTemplate()
export {
	PostTemplate,
	postTemplate
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_async_products_loader/template/PostTemplate.js